/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from "react";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

export interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    selectedIndex: any;
}

export function TabPanel(props: TabPanelProps) {
    const { children, selectedIndex, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={selectedIndex !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {selectedIndex === index && <div>{children}</div>}
        </Typography>
    );
}
